export const BENEFICIARY_TAGS = [
  'beneficiaryDetails',
  'companyBeneficiariesList'
];

export const USER_TAGS = ['userDetails'];

export const ALL_API_TAGS = [...USER_TAGS, ...BENEFICIARY_TAGS] as const;
